/** Prefix for optimistic user rows before POST succeeds; `user-` suffix rows are post-success placeholders. */
export const OPTIMISTIC_ID_PREFIX = 'sparks-optimistic-message-';

/** Page size for GET / AI conversation messages (SWR infinite + optimistic cache). */
export const AI_CONVERSATION_MESSAGES_PAGE_SIZE = 30;

export const DEFAULT_HEIGHT = 500;
export const MIN_HEIGHT = DEFAULT_HEIGHT;
export const CONTAINER_WIDTH = 450;
/** Reserved space from viewport bottom so max height stops at the app corner (bottom-4 + extra for corner alignment). */
export const BOTTOM_GAP = 32;
/** Top navbar height (px). Container max height is limited so it does not overlap the navbar. */
export const TOP_NAVBAR_HEIGHT = 56;
export const GAP_BELOW_NAVBAR = 4;
export const STORAGE_KEY = 'sparks-container-height';
export const STORAGE_KEY_OPEN = 'sparks-container-open';
